import * as React from "react"
import * as styles from "./styles.module.scss"
import cx from "classnames"

export interface TagProps {
  className?: string
  children: string
}

const Tag: React.FC<TagProps> = ({ className, children }) => {
  return (
    <span
      className={cx({
        [styles.tag]: true,
        [`tag-${children}`]: true,
        [`${children}`]: true,
        [className]: className,
      })}
    >
      {children}
    </span>
  )
}

export default Tag
